import * as $ from 'jquery';

export default class NewsroomController {
  private newsList = $('.js-ajaxList--news');

  constructor() {
    this.appendYearSeparator();
    this.initLoadMore();
  }

  initLoadMore() {
    const nextPageElement: HTMLAnchorElement | null = document.querySelector('span[data-auspage-ajax]');
    if (!this.newsList || !nextPageElement) {
      return;
    }
    nextPageElement.addEventListener('click', async (e: Event) => {
      e.preventDefault();
      await this.addElements();
      this.initLoadMore();
    });
  }

  async addElements() {
    const nextPageElement: HTMLAnchorElement | null = document.querySelector('span[data-auspage-ajax]');
    if (!this.newsList || !nextPageElement) {
      return;
    }
    let response;
    try {
      if (nextPageElement.dataset.link) {
        response = await fetch(nextPageElement.dataset.link);
      }
    } catch (e) {
      if (nextPageElement.dataset.link) {
        window.location.href = nextPageElement.dataset.link;
      }
      return;
    }
    const result = await response.text();
    const detachedElement = document.createElement('div');
    detachedElement.innerHTML = result;
    const inner = detachedElement.querySelector('.js-ajaxList--news');
    if (!inner) {
      return;
    }
    nextPageElement.remove();
    this.newsList.append(inner.innerHTML);
    this.appendYearSeparator();
  }

  appendYearSeparator() {
    // unique array of years
    const highlightYear = $('.js-highlightDate').attr('data-year');
    const allYears = this.getYears();

    // adds the separator for each year once
    for (let $i = 1; $i < allYears.length; $i++) {
      const element = this.newsList.find('[data-year=' + allYears[$i] + ']').last();
      if (this.newsList.find(element).next().hasClass('js-ajaxItem')) {
        const thisSeparator = $('<div class="news__yearSeparator clr"></div>').append('<p>' + this.newsList.find(element).next().attr('data-year') +
          '</p>').prop('outerHTML');
        element.after(thisSeparator);
      }
    }

    if (allYears.indexOf(highlightYear) === -1) {
      const firstElement = this.newsList.children().first();
      if (this.newsList.find(firstElement).hasClass('js-ajaxItem')) {
        firstElement.before(
          $('<div class="news__yearSeparator clr"></div>').append(
            '<p>' + this.newsList.find(firstElement).attr('data-year') + '</p>',
          ).prop('outerHTML'),
        );
      }
    }
  }

  getYears() {
    return this.newsList.find('[data-year]').map((index, elem) => {
      return $(elem).attr('data-year');
    }).toArray().reduce(
      (current: Array<any>, next) => {
        if (next !== current[0]) {
          current.unshift(next);
        }
        return current;
      },
      [],
    );
  }
}
